import React from "react";
import {
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";

// Font registration
Font.register({
  family: "Roboto",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/roboto/files/roboto-latin-400-normal.woff",
      fontWeight: "normal",
    },
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/roboto/files/roboto-latin-700-normal.woff",
      fontWeight: "bold",
    },
  ],
});

Font.registerHyphenationCallback(word => [word]);
const styles = StyleSheet.create({
  page: {
    paddingRight: 30,
    paddingLeft: 45,
    fontFamily: "Roboto",
    fontSize: 11,
    position: "relative",
    flexDirection: "column",
    paddingTop: 110,
    paddingBottom: 110,
  },
  logo2: {
    position: "absolute",
    top: 30,
    left: 30,
    width: 60,
  },
  upperDesign: {
    position: "absolute",
    top: -20,
    right: 0,
    width: 280,
  },
  lowerDesign: {
    position: "absolute",
    bottom: -20,
    right: 0,
    width: 300,
  },
  heading: {
    fontSize: 22,
    fontWeight: "bold",
    marginBottom: 10,
    color: "#000",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
    marginTop: 10,
    borderTopWidth: 2,
    borderTopColor: "#000",
    paddingTop: 20,
    paddingBottom: 9,
  },
  section: {
    marginBottom: 15,
  },
  subHeading: {
    fontSize: 19,
    fontWeight: "bold",
  },
  subText: {
    fontSize: 17,
    fontWeight: "bold",
  },
  text: {
    fontSize: 16,
    marginTop: 4,
    fontWeight: "normal",
  },
  pageNumber_Box: {
    position: "absolute",
    bottom: 20,
    left: 10,
    width: 25,
    height: 25,
    border: "2px solid orange",
    borderRadius: 15,
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    zIndex: 2,
  },
  pageNumber: {
    fontSize: 11,
    color: "#000",
    textAlign: "center",
  },
});

const CareerPathways = ({ career, showHeading = false, assets, showPageNumber }) => (
  <Page size="A4" style={styles.page}>
    {/* Decorative fixed images */}
    <Image src={assets.upper} style={styles.upperDesign} fixed />
    <Image src={assets.lower} style={styles.lowerDesign} fixed />
    <Image src={assets.logo2} style={styles.logo2} fixed />

    
    <View style={{ flexDirection: "column" }}>
      {showHeading && (
        <Text style={styles.heading}>
          Where Your Future Could Take You – Top 5 Career Pathways
        </Text>
      )}

      <Text style={styles.title}>{career.title}</Text>

      <View style={styles.section}>
        <Text style={styles.subHeading}>Why it matches you</Text>
        <Text style={styles.text}>{career.why_it_matches_your_profile}</Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.subText}>
          Key Roles:{" "}
          <Text style={styles.text}>{career.key_roles.join(", ")}</Text>
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.subText}>
          Future Possibilities:{" "}
          <Text style={styles.text}>{career.future_possibilities}</Text>
        </Text>
      </View>
    </View>

    {/* Footer - page number only */}
    <>
      {showPageNumber && (
        <View style={styles.pageNumber_Box} fixed>
          <Text
            style={styles.pageNumber}
            render={({ pageNumber }) => `${pageNumber}`}
            fixed
          />
        </View>
      )}
    </>
  </Page>
);

export default CareerPathways;
